import React,{useEffect} from "react";
import { useParams } from "react-router-dom";
import { baldivisServices } from "../Data";
import ErrorPage from './ErrorPage'
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import AboutService from "../Components/AboutService";
import WhyChoose from "../Components/WhyChoose";
import ProcessSection from "../Components/Process";
import ServiceFaq from "../Components/ServiceFaq";
import ServiceRegion from "../Components/ServiceRegion";
import Services from "../Components/Services";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import serviceSchema from '../Schemas/serviceSchema';
import breadcrumbSchema from '../Schemas/breadcrumbSchema'
import faqSchema from "../Schemas/faqSchema";

const ServiceDetailBaldivis=()=>{
const { slug } = useParams();

  const service = baldivisServices.find(item => item.slug === slug);
  const schema = serviceSchema(service, slug);
  const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: "Services in Baldivis",
    url: "https://ldlsettlementservices.com.au/services/baldivis/"
  },
  {
    name: service?.title
  }
]);

const serviceFaqSchema = faqSchema(service.faqs);

  useEffect(() => {
      if (!service) return;
      document.title = `${service.metaTitle}`;

      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
      if (metaDesc) {
        metaDesc.setAttribute("content", service.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://ldlsettlementservices.com.au/services/baldivis/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      service.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      service.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://ldlsettlementservices.com.au/services/baldivis/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     service.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    service.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
  }

    }, [service, slug]);


  if (!service) {
    return <ErrorPage />;
  }
    return(
        <>
         <React.Fragment key={slug}>

         <SchemaMarkup schema={schema} />
           <SchemaMarkup schema={breadcrumbs} />
           {serviceFaqSchema && (
  <SchemaMarkup schema={serviceFaqSchema} />
)}

 {/**HEADER */}
        <Header
  showBreadcrumb={true}
  breadcrumbItems={[
    {
      label: "Services in Baldivis",
      link: "/services/baldivis",
    },
    {
      label: service.title,
    },
  ]}
/>
         {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="OUR SERVICES"
      title={service.heroTitle}
      description={service.heroDesc}
      image={service.img}
      showIcons={true}
    />

        {/**ABOUT THE SERVICE - POINTS SECTION */}
        <div className="special-page">
        <AboutService
  title={service.aboutTitle}
  desc={service.aboutDesc}
  points={service.aboutPoints}
  isLongHeading={service.isLongHeading}
/>
</div>

        {/**WHY CHOOSE US SECTION */}
        <div className="special-page">
    <WhyChoose
    heading={service.whyChooseHeading}
    image={service.whyChooseImg}
    desc={service.whyChooseDesc}
    reverse={true}
    />
    </div>

    {/**PROCESS SECTION */}
    <ProcessSection 
    heading={service.processHeading}
    desc={service.processDesc}
    />

    {/**FAQS + CTA SECTION */}
    <ServiceFaq
    faqData={service.faqs}
    ctaBg={service.ctaImg}
    />

    {/**SERVICES IN PERTH + WA SECTION */}
    <ServiceRegion
        title={service.regionTitle}
        desc={service.regionDesc}
        icon={service.icon}
        basePath={service.slug}
    />

    {/**OTHER SERVICES SECTION */}
    <Services
  excludeSlug={service.slug}
  sliderHeading={service.otherServiceHeading}
  desc={service.otherServiceDesc}
basePath="/services/baldivis"
/>

    {/**CTA SECTION */}
    <Cta 
    heading={service.ctaHeading}
    desc={service.ctaDesc}
    />


         </React.Fragment>
        </>
    )
}
export default ServiceDetailBaldivis;